/**
 * Paginated response from backend (matches snake_case)
 */
export interface PaginatedResponse<T> {
  items: T[];
  total: number;
  limit: number;
  offset: number;
  has_more: boolean;
}

export const Status = {
  Active: "active",
  Inactive: "inactive",
} as const;

export type Status = (typeof Status)[keyof typeof Status];

export enum UserRole {
  OrgLeader = "Organization Leader",
  SuperAdmin = "Super Admin",
  OrganizationOwner = "Organisation Owner",
}

